/**
 * Created by wipsteve on 11/11/2019.
 */
export default class HeaderNav{
  get SELECTORS(){
    return{
      guestHeader: '.header--guest',
      mainHeader: '.c-ifch-header',
      mainContentPage: '.ifch-main-content',
    }
  }
  constructor (){
    this.cssScrolled = 'scrolled';
    this.cssGuestHeader = 'header--guest';
    this.cssPublic = 'public';
  }
  init(){
    if(document.querySelector(this.SELECTORS.mainHeader)){
      this.headerHandler();
    }
  }
  getHeader(){
    return document.querySelector(this.SELECTORS.mainHeader);
  }
  isScrolled(){
    return this.getHeader().classList.contains(this.cssScrolled);
  }
  headerHandler(){
    let headerHeight = this.getHeader().offsetHeight;
    this.setContentDistance();
    window.addEventListener('scroll',(e)=>{
  
      if(window.pageYOffset > headerHeight){
        this.getHeader().classList.add(this.cssScrolled);
      }else{
        if(this.isScrolled()){
          this.getHeader().classList.remove(this.cssScrolled);
        }
      }
    })
  }
  setContentDistance(){
    let height = this.getHeader().offsetHeight;
    let content = document.querySelector(this.SELECTORS.mainContentPage);
    if(!this.getHeader().classList.contains(this.cssGuestHeader)){
      content.style.paddingTop = `${height}px`;
    }else if(this.getHeader().classList.contains(this.cssPublic)){
      content.style.paddingTop = `${height}px`;
    }
  }
}